"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classReducer = _interopRequireDefault(require("./_classReducer"));
var _actionTypes = require("../actions/actionTypes");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable class-methods-use-this */
var initialState = {};
var PersistenceReducer = /*#__PURE__*/(0, _createClass2["default"])(function PersistenceReducer() {
  (0, _classCallCheck2["default"])(this, PersistenceReducer);
  (0, _defineProperty2["default"])(this, _actionTypes.PERSIST_CHOICES, function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var productId = action.productId,
      persistenceKey = action.persistenceKey,
      selectedChoices = action.selectedChoices,
      updatedChoice = action.updatedChoice;
    if (!persistenceKey) {
      return state;
    }
    var formattedPersistObj = {};
    selectedChoices.forEach(function (choice) {
      var choiceId = choice.id,
        choiceValue = choice.value,
        optionId = choice.optionId;
      formattedPersistObj[optionId] = {
        choiceId: choiceId,
        choiceValue: choiceValue
      };
    });
    var optionId = updatedChoice.optionId,
      choiceId = updatedChoice.choiceId,
      choiceValue = updatedChoice.choiceValue;
    formattedPersistObj[optionId] = {
      choiceId: choiceId,
      choiceValue: choiceValue
    };
    return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2["default"])({}, persistenceKey, _objectSpread(_objectSpread({}, state[persistenceKey]), {}, (0, _defineProperty2["default"])({}, productId, _objectSpread(_objectSpread({}, (state[persistenceKey] || {})[productId]), formattedPersistObj)))));
  });
  (0, _defineProperty2["default"])(this, _actionTypes.PERSIST_LOADED_CHOICES, function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var productId = action.productId,
      choices = action.choices,
      persistenceKey = action.persistenceKey;
    if (!persistenceKey) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2["default"])({}, persistenceKey, _objectSpread(_objectSpread({}, state[persistenceKey]), {}, (0, _defineProperty2["default"])({}, productId, _objectSpread(_objectSpread({}, (state[persistenceKey] || {})[productId]), choices)))));
  });
  (0, _defineProperty2["default"])(this, _actionTypes.CLEAR_PERSISTED_CHOICES, function () {
    return initialState;
  });
});
var _default = exports["default"] = (0, _classReducer["default"])(PersistenceReducer);
//# sourceMappingURL=persistenceReducer.js.map